/*
 * @Description: 附件管理
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export const Download = "/base/system/base/enclosure/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/base/enclosure/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function getDetail(params) {
  return request({
    url: '/base/system/base/enclosure/get_detail',
    method: 'get',
    params
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/base/enclosure/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/base/enclosure/save_or_update',
    method: 'post',
    data
  })
}
